import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { SERVICES } from "@/constants/testIds";
import { SERVICE_PAYMENT_OVERRIDE_OPTIONS } from "@/lib/pricingUtils";

/** Excepcion por servicio al modo de cobro general de la reserva publica
 * (configurado en Ajustes). "Heredar" = usar la configuracion de la clinica. */
export default function ServicePaymentOverrideSection({ form, setForm }) {
  return (
    <div className="border border-border rounded-lg p-3 space-y-3">
      <div>
        <Label className="text-sm font-medium text-foreground">Cobro al reservar online</Label>
        <p className="text-xs text-muted-foreground">
          Por defecto usa la configuración general de Ajustes. Podés definir una excepción para este servicio.
        </p>
      </div>
      <Select value={form.payment_mode_override} onValueChange={(v) => setForm((f) => ({ ...f, payment_mode_override: v }))}>
        <SelectTrigger data-testid={SERVICES.modalPaymentModeSelect}><SelectValue /></SelectTrigger>
        <SelectContent>
          {SERVICE_PAYMENT_OVERRIDE_OPTIONS.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
        </SelectContent>
      </Select>
      {form.payment_mode_override === "deposit" && (
        <div className="flex items-center gap-3">
          <Select value={form.deposit_type_override} onValueChange={(v) => setForm((f) => ({ ...f, deposit_type_override: v }))}>
            <SelectTrigger className="w-40" data-testid={SERVICES.modalPaymentDepositTypeSelect}><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="percentage">Porcentaje (%)</SelectItem>
              <SelectItem value="fixed">Monto fijo (USD)</SelectItem>
            </SelectContent>
          </Select>
          <Input
            type="number" min="0" step="0.01" className="w-32"
            value={form.deposit_value_override}
            onChange={(e) => setForm((f) => ({ ...f, deposit_value_override: e.target.value }))}
            data-testid={SERVICES.modalPaymentDepositValueInput}
          />
        </div>
      )}
    </div>
  );
}
